import { createSlice } from "@reduxjs/toolkit";
import {
  createCommunityCategory,
  deleteCommunityCategory,
  getCommunityCategory,
  undoDeleteCommunityCategory,
} from "./communityCategory.api";

const communityCategorySlice = createSlice({
  name: "communityCategory",
  initialState: {
    communityCategory: { data: [] },
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCommunityCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCommunityCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(createCommunityCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });

    // GET Banner FILTER WISE DATA
    builder.addCase(getCommunityCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getCommunityCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.communityCategory = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getCommunityCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteCommunityCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteCommunityCategory.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.communityCategory.data) {
        state.communityCategory.data = state.communityCategory.data.filter(
          (communityCategory) => {
            return communityCategory._id !== deletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.communityCategory.data is not an array:",
          state.communityCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteCommunityCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteCommunityCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteCommunityCategory.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.communityCategory.data) {
        state.communityCategory.data = state.communityCategory.data.filter(
          (communityCategory) => {
            return communityCategory._id !== undodeletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.communityCategory.data is not an array:",
          state.communityCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteCommunityCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = communityCategorySlice.actions;
export default communityCategorySlice.reducer;
